import { BigIconButton } from '@socialchorus/shared-ui-components';
import { usePatronSelector } from '../../../../common/use-patron-selector';
import {
  AssistantIntegration,
  getIntegration,
} from '../../../../models/assistant/selectors';
import Tooltip from '../../../tooltip/tooltip';
import { LinkNavigation } from '@socialchorus/shared-ui-components/dist/components/Link';

export interface ShortcutButtonProps {
  id: AssistantIntegration['id'];
  label: string;
  iconSrc?: string;
  href?: string | LinkNavigation;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  target?: string;
  rel?: string;
  description?: string;
}

const ShortcutButton = ({
  id,
  iconSrc,
  label,
  href,
  onClick,
  className,
  target,
  rel,
  description,
}: ShortcutButtonProps) => {
  const integration = usePatronSelector((state) =>
    getIntegration(state, { integrationId: id })
  );

  const tooltipId = `shortcut-button-${id}--tooltip`;
  const tooltipLabel = description || integration?.subject.description;

  return tooltipLabel ? (
    <Tooltip
      id={tooltipId}
      text={integration?.subject.description || description || ''}
      options={{ placement: 'bottom' }}
    >
      {({
        tooltipRef,
        onMouseEnter,
        onMouseLeave,
        onFocus,
        onBlur,
        onKeyDown,
      }) => {
        return (
          <BigIconButton
            role="link"
            imgSrc={iconSrc}
            label={label}
            aria-describedby={tooltipId}
            href={href}
            onClick={onClick}
            ref={tooltipRef}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            className={className}
            target={target}
            rel={rel}
          />
        );
      }}
    </Tooltip>
  ) : (
    <BigIconButton
      role="link"
      imgSrc={iconSrc}
      label={label}
      aria-describedby={tooltipId}
      href={href}
      onClick={onClick}
      className={className}
      target={target}
      rel={rel}
    />
  );
};

export default ShortcutButton;
